import React from "react";

import { connect } from "react-redux";
import { hot } from "react-hot-loader/root";
import { withRouter } from "react-router-dom";
import  TrackerViewerView  from './View'

import {
     getContractDataById, clearSuccessMsg, getDataModelById, getModelDataDropDown, initiateAction, updateDataModelData, getMembersList, clearReduxDataOfCurrentComponent, getModelData, getGroupsByMemberId, getNextRespondent, getDataModels, createOpportunity, getAllOpportunities, deleteOpportunity, getSingleOpportunity, updateOpportunity, createActionForOpportunity, getAllActionsOfOpportunity, getSingleActionOfOpportunity, updateSingleActionOfOpportunity, deleteSingleActionOfOpportunity, getDocumentsFromIDsOfOpportunity, uploadAttachmentOpportunity, deleteAttachmentsForOpportunity, downloadContractPDFAction, getWorkflowById,getNextTasks, executeWorkFlow, executeWorkFlowReject, createTaskForObligations, getAllTaskofobligation, getSingleTaskofobligation, initiateworkFlowObligations, changeAssigneeRequest, updateSingleTaskofobligation, getFirstStepMembers, acceptWorkFlowObligations, deleteTaskofobligation, currentStepMembersForobligation,
    rejectedWorkFlowObligations, addComment, getAuditTrailsData, completedWorkFlowObligations, getContractHierarchys, downloadSheet, getSpendDetails, getSpendFilters, createDocument, globalAuditTrailsData, getDealReviewHistory, saveDealReviewHistory
} from '../../store/actions';

import { Loader } from "../loader";
import { PUBLIC_PATH } from '../../constants';


const TrackerViewer = (props) => {
    const currentDocumentId = props?.match?.params?.id;
     
    return (
        <TrackerViewerView
            {...props}
            appId={props.match.params.appid}
            orgId={props.appConfig?.org?._id}
            currentDocumentId={currentDocumentId}
            loader={<Loader />}
        />
    )
}

const mapDispatchToProps = {
    getContractDataById,
    updateDataModelData,
    clearSuccessMsg,
    getModelDataDropDown,
    initiateAction,
    getMembersList,
    clearReduxDataOfCurrentComponent,
    getDataModelById,
    getModelData,
    getDataModels,
    getGroupsByMemberId,
    getNextRespondent,
    
    createOpportunity,
    getAllOpportunities,
    deleteOpportunity,
    getSingleOpportunity,
    updateOpportunity,
    createActionForOpportunity,
    getAllActionsOfOpportunity,
    getSingleActionOfOpportunity,
    updateSingleActionOfOpportunity,
    deleteSingleActionOfOpportunity,
    getDocumentsFromIDsOfOpportunity,
    uploadAttachmentOpportunity,
    deleteAttachmentsForOpportunity,
    downloadContractPDFAction,
    getWorkflowById,
    getNextTasks,
    executeWorkFlow,
    executeWorkFlowReject,
    createTaskForObligations,
    getAllTaskofobligation,
    getSingleTaskofobligation,
    initiateworkFlowObligations,
    changeAssigneeRequest,
    updateSingleTaskofobligation,
    getFirstStepMembers,
    acceptWorkFlowObligations,
    rejectedWorkFlowObligations,
    completedWorkFlowObligations,
    deleteTaskofobligation,
    currentStepMembersForobligation,
    addComment,
    getAuditTrailsData,
    getContractHierarchys,
    downloadSheet,
    getSpendDetails,
    getSpendFilters,
    createDocument,
    globalAuditTrailsData,
    getDealReviewHistory,
    saveDealReviewHistory
};

const mapStateToProps = state => {
    return {
        formData: state.form,
        action: state.action,
        appConfig: state.appConfig.app,
        PUBLIC_PATH: PUBLIC_PATH,
        members: state.appConfig.members,
        dataModels: state.dataModels,
        user: state.user,
        appConfiguration: state.form.document?.appConfig
    };
};

export default hot(withRouter(connect(mapStateToProps, mapDispatchToProps)(TrackerViewer)));